import DefaultDetail from "@Common/DefaultDetail";
import { handleCopyBuffer } from "@utils";
import { computed } from "mobx";
import { inject, observer } from "mobx-react";
import { useParams } from "react-router-dom";

const ProjectsDetail = inject("mainStore")(
    observer(({ mainStore }) => {
        const detailData = computed(() => mainStore.getMainStore("detailData")).get();
        const { secondParam } = useParams();

        const isAdd = secondParam === "add" || false;

        let inputs = [
            {
                blockName: "Витрина",
                inputs: {
                    name: { label: "Название витрины", type: "string", required: true, addClass: "full", translitTo: "code", duplicateToPath: ["name"] },
                    domain: { label: "Домен", type: "string", required: false, addClass: "half", disabled: true, placeholder: "Генерируется автоматически" },
                    copyBtn: {
                        label: "",
                        type: "btn",
                        required: false,
                        addClass: "",
                        icon: "pi pi-copy",
                        text: true,
                        style: { "align-self": "flex-end", height: 46, color: "black" },
                        onClick: (e) => handleCopyBuffer(e, detailData, "domain", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Витрина запущена`, detail: "ссылка на домен скопирована в буфер обмена" })),
                    },
                    siteInfo: {
                        type: "objectInputs",
                        inputs: {
                            categoriesIds: {
                                label: "Категории",
                                type: "multiSelect",
                                required: true,
                                apiUrl: "/promo/suggest_list?collection=categories&project[_id]=1&project[code]=1&project[title]=1&sortField=name&sortOrder=asc",
                                dataKey: "suggest.categories_suggest",
                                optionValue: "_id",
                                optionLabel: "title",
                                placeholder: "Выберите категории",
                                selectedItemKey: "_id",
                                appendTo: "self",
                                addClass: "full",
                            },
                        },
                    },
                },
            },
            {
                blockName: "Юридическая информация",
                inputs: {
                    siteInfo: {
                        type: "objectInputs",
                        inputs: {
                            fullOpf: { label: "Юридическое название вендора", type: "string", placeholder: "ООО “Название вендора" },
                            numberAgreement: { label: "Номер договора", type: "string", placeholder: "0000000000000" },
                            numberApplication: { label: "Номера приложений / Дополнительных соглашений", type: "string", placeholder: "0000000000000" },
                            INN: { label: "ИНН", type: "number", mode: "decimal", placeholder: "0000000000000", maxLength: 10, minLength: 10, useGrouping: false },
                        },
                    },
                },
            },

            {
                blockName: "Информация оплаты по площадкам",
                inputs: {
                    rateIds: {
                        type: "ratesTraffic",
                        label: "Укажите ставки",
                        apiUrl: "/promo/suggest_list?collection=siterates",
                    },
                },
            },
        ];

        const funcAfterSave = (e, data) => handleCopyBuffer(e, data, "domain", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Витрина запущена`, detail: "ссылка на домен скопирована в буфер обмена" })); // копируем в буфер ссылку на домен

        if (isAdd) {
            delete inputs[0].inputs.copyBtn; //убираем кнопку копирования при создании
            delete inputs[2]; // удаляем ставки при создании
        }
        return (
            <DefaultDetail
                apiUrl={secondParam === "add" ? "/promo/sites" : `/promo/sites/${secondParam}`}
                dataKey={secondParam}
                scopes={false}
                inputs={inputs}
                title="витрину"
                titleList={"title"}
                titleRight={"проекты"}
                urlUpload={"project"}
                page={"project"}
                logging
                funcAfterSave={funcAfterSave} // что то выполнить после сохрания (создания) записи
            />
        );
    }),
);

export default ProjectsDetail;
